<template>
	<div class="brick">
		<label v-if="restriction_only_available" class="mgr_15"><input type="checkbox" v-model="restriction_only" @change="onStateReportChange" /> Restriction Only</label>
		<div class="list_top_box">
			<div class="left_option">
				<p class="mgb_10">
					<em class="lt_text">Invoice Period </em>
					<span class="int_type_no_border">
						<CodeSelect :showDesc="false" :width="100" :displayName="false" :codes="fromYears" v-model="from_year" />
					</span>
					<span> ~ </span>
					<span class="int_type_no_border mgr_15">
						<CodeSelect :showDesc="false" :width="100" :displayName="false" :codes="toYears" v-model="to_year" />
					</span>

					<em class="lt_text">Country </em>
					<span class="int_type_no_border mgr_5">
						<CodeSelect :disabled="exclude_us" :showDesc="false" :width="100" :codes="countries" v-model="country" />
					</span>
					<label class="mgr_10"><input type="checkbox" @change="excludeUS" v-model="exclude_us" /> Non-US</label>

					<em class="lt_text">State </em>
					<span class="int_type_no_border mgr_15">
						<CodeSelect :disabled="exclude_us" :showDesc="false" :width="100" :codeWidth="120" :codes="filteredStates" v-model="state" />
					</span>

					<em class="lt_text">Sales Group</em>
					<span class="int_type_no_border mgr_15">
						<CodeSelect :showDesc="false" className="tbl_select" :codes="restriction_only && state_report_filters ? state_report_filters.restrictionOnlySalesGroupList : salesGroups" v-model="sales_group_code" />
					</span>

					<a href="javascript:;" class="search_bt mgr_5" @click="getSalesPerYear">Search</a>
					<span v-show="sales_list && sales_list.length">
						<!-- <a href="javascript:void(0);" class="gray_bt mgr_10" v-on:click="reportPrint">Print</a> -->
						<a href="javascript:void(0);" class="gray_bt" v-on:click="excelExport">Excel</a>
					</span>
				</p>
			</div>
		</div>

		<table v-if="sales_list.length > 0">
			<tr>
				<td style="vertical-align: top; width: 20%;">
					<div style="overflow-y: hidden; overflow-x: hidden;">
						<table class="list_tbl" style="table-layout: fixed;">
							<thead>
								<tr>
									<th colspan="3" class="truncate border_right">{{ search_to_year }} ~ {{ search_from_year }}</th>
								</tr>
								<tr>
									<th class="truncate border_right">Country</th>
									<th class="truncate border_right">State</th>
									<th class="truncate border_right">Sales Group</th>
								</tr>
							</thead>
						</table>
					</div>
				</td>
				<td style="vertical-align: top; width: 80%;">
					<div ref="rightHeader" style="overflow-y: hidden; overflow-x: hidden; width: 100%; padding-right: 17px;">
						<table class="list_tbl" :style="{ 'table-layout': 'fixed', width: 'calc(' + (search_to_year - search_from_year + 1) * 20 + '% + 17px)' }">
							<thead>
								<tr>
									<th class="truncate border_right" colspan="2" v-for="(i, index) in search_to_year - search_from_year + 1" :key="i">{{ search_from_year + index }}</th>
									<th class="border_none" style="width: 17px;"></th>
								</tr>
								<tr>
									<template v-for="i in search_to_year - search_from_year + 1">
										<th class="truncate border_right" :key="i + 'net'">Net</th>
										<th class="truncate border_right" :key="i + 'return'">Return</th>
									</template>
									<th class="border_none" style="width: 17px;"></th>
								</tr>
							</thead>
						</table>
					</div>
				</td>
			</tr>

			<tr>
				<td style="vertical-align: top; width: 20%;">
					<div ref="leftContent" style="overflow-y: hidden; overflow-x: hidden; vertical-align: top; height: 700px;">
						<table class="list_tbl" style="table-layout: fixed;">
							<tbody>
								<tr v-for="(item, index) in sales_list" :key="index" class="normal_tbl">
									<td v-if="item.country_row" :rowspan="item.country_row" class="truncate">
										{{ item.country_name ? item.country_name : item.country_code ? '(' + item.country_code + ')' : '(Unknown)' }}
									</td>
									<td v-if="item.state_row" :rowspan="item.state_row" class="truncate">{{ item.state }}</td>
									<td class="truncate" :class="{ backgroud_gray: item.sales_group_code === 'total_row' }">{{ item.sales_group_name ? item.sales_group_name : item.sales_group_code ? '(' + item.sales_group_code + ')' : '(Unknown)' }}</td>
								</tr>
								<tr class="normal_tbl">
									<td colspan="3" class="al_right"><b>Total</b></td>
								</tr>
								<tr class="normal_tbl">
									<td class="border_none" style="height: 17px;"></td>
								</tr>
							</tbody>
						</table>
					</div>
				</td>
				<td style="vertical-align: top; width: 80%;">
					<div ref="rightContent" style="overflow-x:scroll; overflow-y:scroll; width: 100%; height: 700px;" @scroll="dataOnScroll">
						<table class="list_tbl" :style="{ 'table-layout': 'fixed', width: 'calc(' + (search_to_year - search_from_year + 1) * 20 + '%' }">
							<tbody>
								<tr v-for="(item, index) in sales_list" :key="index" class="normal_tbl">
									<template v-for="(i, jIndex) in search_to_year - search_from_year + 1">
										<td class="al_right" :class="{ backgroud_gray: item.sales_group_code === 'total_row' }" :key="i + 'net'">
											{{ item.amount_in_year && item.amount_in_year.find(el => el.year === search_from_year + jIndex) ? item.amount_in_year.find(el => el.year === search_from_year + jIndex).net_sales : 0 | toCurrency }}
										</td>
										<td class="al_right" :class="{ backgroud_gray: item.sales_group_code === 'total_row' }" :key="i + 'return'">
											{{ item.amount_in_year && item.amount_in_year.find(el => el.year === search_from_year + jIndex) ? item.amount_in_year.find(el => el.year === search_from_year + jIndex).return_amt : 0 | toCurrency }}
										</td>
									</template>
								</tr>
								<tr class="normal_tbl">
									<template v-for="(i, index) in search_to_year - search_from_year + 1">
										<td class="al_right" :key="i + 'net_t'">
											<b>{{ total_amt.find(el => el.year === search_from_year + index).net_sales | toCurrency }}</b>
										</td>
										<td class="al_right" :key="i + 'return_t'">
											<b>{{ total_amt.find(el => el.year === search_from_year + index).return_amt | toCurrency }}</b>
										</td>
									</template>
								</tr>
							</tbody>
						</table>
					</div>
				</td>
			</tr>
		</table>

		<table v-if="sales_list.length > 0" v-show="false" class="list_tbl" id="sales_per_year">
			<thead>
				<tr>
					<th colspan="3">{{ search_to_year }} ~ {{ search_from_year }}</th>
					<th colspan="2" v-for="(i, index) in search_to_year - search_from_year + 1" :key="i">
						{{ search_from_year + index }}
					</th>
				</tr>
				<tr>
					<th>Country</th>
					<th>State</th>
					<th>Sales Group</th>
					<template v-for="i in search_to_year - search_from_year + 1">
						<th :key="'excel_th_net' + i">Net</th>
						<th :key="'excel_th_return' + i">Return</th>
					</template>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(item, index) in sales_list" :key="index" class="normal_tbl">
					<td v-if="item.country_row" :rowspan="item.country_row">
						{{ item.country_name ? item.country_name : item.country_code ? '(' + item.country_code + ')' : '(Unknown)' }}
					</td>
					<td v-if="item.state_row" :rowspan="item.state_row">{{ item.state }}</td>
					<td :class="{ backgroud_gray: item.sales_group_code === 'total_row' }">{{ item.sales_group_name ? item.sales_group_name : item.sales_group_code ? '(' + item.sales_group_code + ')' : '(Unknown)' }}</td>
					<template class="al_right" v-for="(i, jIndex) in search_to_year - search_from_year + 1">
						<td :class="{ backgroud_gray: item.sales_group_code === 'total_row' }" :key="index + 'excel_td_net' + i">
							{{ item.amount_in_year && item.amount_in_year.find(el => el.year === search_from_year + jIndex) ? item.amount_in_year.find(el => el.year === search_from_year + jIndex).net_sales : 0 | toCurrency }}
						</td>
						<td :class="{ backgroud_gray: item.sales_group_code === 'total_row' }" :key="index + 'excel_td_return' + i">
							{{ item.amount_in_year && item.amount_in_year.find(el => el.year === search_from_year + jIndex) ? item.amount_in_year.find(el => el.year === search_from_year + jIndex).return_amt : 0 | toCurrency }}
						</td>
					</template>
				</tr>
				<tr class="normal_tbl">
					<td colspan="3" class="al_right"><b>Total</b></td>
					<template v-for="(i, index) in search_to_year - search_from_year + 1">
						<td class="al_right" :key="i + 'excel_net_t'">
							<b>{{ total_amt.find(el => el.year === search_from_year + index).net_sales | toCurrency }}</b>
						</td>
						<td class="al_right" :key="i + 'excel_return_t'">
							<b>{{ total_amt.find(el => el.year === search_from_year + index).return_amt | toCurrency }}</b>
						</td>
					</template>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
import stateReport from '@/mixins/stateReport';
import CodeSelect from '@/components/common/CodeSelect';
import { apiSalesPerYear } from '@/api/report/report';
import { toYear } from '@/utils/date';
import { apiIndex } from '@/api/partner/index.js';
import { exportExcel, objectCopy } from '@/api/util';
export default {
	mixins: [stateReport({ id: 'SalesTemplateYearly', search: 'getSalesPerYear', queries: ['getSalesPerYear'], results: ['sales_list', 'search_country', 'search_from_year', 'search_sales_group_code', 'search_state', 'search_to_year'] })],
	data: () => ({
		from_year: null,
		to_year: null,
		state: null,
		country: null,
		sales_group_code: null,

		sales_list: [],

		search_from_year: null,
		search_to_year: null,
		search_state: null,
		search_country: null,
		search_sales_group_code: null,
		search_exclude_us: false,

		states: [],
		countries: [],
		salesGroups: [],

		fromYears: [],
		toYears: [],

		year_list_count: 50,
		exclude_us: false,
	}),
	components: {
		CodeSelect,
	},
	computed: {
		user: function() {
			return this.$session.get('user');
		},
		filteredStates: {
			get() {
				if (!this.country && this.user.company_id == 'newjigu') return this.states;
				return this.states.filter(s => s.country == this.country);
			},
		},
		total_amt: {
			get() {
				let total_amt = [];
				for (let year = this.search_from_year; year < this.search_to_year + 1; year++) {
					let net_sales_in_year = 0;
					let return_amt_in_year = 0;
					let gross_sales_in_year = 0;
					for (let sales of this.sales_list) {
						if (sales.sales_group_code !== 'total_row') continue; // 주(state)별 합계 행
						if (sales.amount_in_year && sales.amount_in_year.find(el => el.year === year)) {
							net_sales_in_year += sales.amount_in_year.find(el => el.year === year).net_sales;
							return_amt_in_year += sales.amount_in_year.find(el => el.year === year).return_amt;
							gross_sales_in_year += sales.amount_in_year.find(el => el.year === year).gross_sales;
						}
					}

					total_amt.push({ year: year, net_sales: net_sales_in_year, return_amt: return_amt_in_year, gross_sales: gross_sales_in_year });
				}

				return total_amt;
			},
		},
	},
	watch: {
		country: {
			handler() {
				this.state = null;
			},
		},
		to_year: {
			handler() {
				let fromYears = [];
				for (let i = 0; i < this.year_list_count; i++) {
					fromYears.push({ code: String(this.to_year - i), name: String(this.to_year - i) });
				}

				this.fromYears = fromYears;
			},
		},
	},
	methods: {
		excelExport() {
			if (this.state_report_pending) return;
			if (!this.sales_list || !this.sales_list.length) return this.$toast.error('No List To Export');
			exportExcel('sales_per_year', 'sales_per_year');
		},
		setSpanCount(sales_list) {
			let temp_country_index = 0;
			let temp_state_index = 0;
			let country_span_cnt = 0;
			let state_span_cnt = 0;
			for (let i = 0; i < sales_list.length; i++) {
				if (i === 0) {
					country_span_cnt++;
					state_span_cnt++;
				} else if (sales_list[i - 1].country_code === sales_list[i].country_code) {
					country_span_cnt++;

					if (sales_list[i - 1].state === sales_list[i].state) state_span_cnt++;
					else {
						sales_list[temp_state_index].state_row = state_span_cnt;
						temp_state_index = i;
						state_span_cnt = 1;
					}
				} else {
					sales_list[temp_country_index].country_row = country_span_cnt;
					temp_country_index = i;
					country_span_cnt = 1;

					sales_list[temp_state_index].state_row = state_span_cnt;
					temp_state_index = i;
					state_span_cnt = 1;
				}
			}

			if (sales_list.length > temp_country_index) sales_list[temp_country_index].country_row = country_span_cnt;
			if (sales_list.length > temp_state_index) sales_list[temp_state_index].state_row = state_span_cnt;
		},
		setTotalAmtPerState(sales_list) {
			let country_idx = 0;
			for (let i = 0; i < sales_list.length; i++) {
				if (sales_list[i].country_row) country_idx = i;

				if (sales_list[i].state_row) {
					let total_amt_list = Array.isArray(sales_list[i].amount_in_year) ? objectCopy(sales_list[i].amount_in_year) : [];
					for (let j = i + 1; j < i + sales_list[i].state_row; j++) {
						if (Array.isArray(sales_list[j].amount_in_year)) {
							for (let k = 0; k < sales_list[j].amount_in_year.length; k++) {
								let year = sales_list[j].amount_in_year[k].year;
								let idx = total_amt_list.findIndex(el => el.year === year);
								if (idx > -1) {
									total_amt_list[idx].gross_sales += sales_list[j].amount_in_year[k].gross_sales;
									total_amt_list[idx].return_amt += sales_list[j].amount_in_year[k].return_amt;
									total_amt_list[idx].net_sales += sales_list[j].amount_in_year[k].net_sales;
								} else {
									total_amt_list.push({
										year: sales_list[j].amount_in_year[k].year,
										gross_sales: sales_list[j].amount_in_year[k].gross_sales,
										return_amt: sales_list[j].amount_in_year[k].return_amt,
										net_sales: sales_list[j].amount_in_year[k].net_sales,
									});
								}
							}
						}
					}

					let obj = { country_code: sales_list[i].country_code, country_name: sales_list[i].country_name, state: sales_list[i].state, sales_group_code: 'total_row', sales_group_name: 'Total', amount_in_year: total_amt_list };
					sales_list.splice(i + sales_list[i].state_row, 0, obj);
					sales_list[i].state_row++;
					sales_list[country_idx].country_row++;
				}
			}
		},
		async getSalesPerYear() {
			this.from_year = this.from_year || null;
			this.to_year = this.to_year || null;
			this.country = this.country || null;
			this.state = this.state || null;
			this.sales_group_code = this.sales_group_code || null;
			this.exclude_us = this.exclude_us || false;

			let { data } = await apiSalesPerYear.call(this, this.from_year, this.to_year, this.country, this.state, this.sales_group_code, this.exclude_us);
			this.setSpanCount(data);
			this.setTotalAmtPerState(data);
			this.sales_list = data;

			this.search_from_year = Number(this.from_year);
			this.search_to_year = Number(this.to_year);
			this.search_country = this.country;
			this.search_state = this.state;
			this.search_sales_group_code = this.sales_group_code;
		},
		async index() {
			const { data } = await apiIndex();

			this.states = data.stateList;
			this.countries = data.countryList;
			this.salesGroups = data.salesGroupList;
		},
		initYearList() {
			let thisYear = toYear();
			let fromYears = [];
			let toYears = [];
			for (let i = 0; i < this.year_list_count; i++) {
				fromYears.push({ code: String(thisYear - i), name: String(thisYear - i) });
				toYears.push({ code: String(thisYear - i), name: String(thisYear - i) });
			}

			this.fromYears = fromYears;
			this.toYears = toYears;
		},
		excludeUS() {
			if (this.exclude_us) {
				this.country = null;
				this.state = null;
			}
		},
		dataOnScroll: function() {
			let leftContent = this.$refs['leftContent'];
			let rightContent = this.$refs['rightContent'];
			let rightHeader = this.$refs['rightHeader'];

			leftContent.scrollTop = rightContent.scrollTop;
			rightHeader.scrollLeft = rightContent.scrollLeft;
		},
	},
	async created() {
		this.$store.commit('setSideIndex', 7);
		this.$store.commit('setSelectedMenu', 'nav_li_salesTemplateYearly');
		this.$store.commit('setSubTitle', 'Report -> Sales Template(Yearly)');

		await this.index();
		this.initYearList();
	},
};
</script>

<style scoped scss="lang">
.backgroud_gray {
	background: #dddddd !important;
}
.list_tbl .normal_tbl td {
	background-color: white;
}

.list_tbl .normal_tbl td:last-child {
	border-right: 1px solid #dbdbdb;
}

.td_bold td {
	font-weight: bold;
	font-size: 15px;
}
.list_tbl .border_right {
	border-right: 1px solid #dbdbdb !important;
}
.border_none {
	border: none !important;
	background: none !important;
}
</style>
